import React from "react";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";


interface Asset {
    asset_name: string;
    asset_attachement: string;
    assets_type: string;
}

interface Props {
    title: string;
    assets: Asset[];
}

const AssetSection: React.FC<Props> = ({ title, assets }) => {
    // console.log(title)
    // console.log(assets)
    // const getImageSrc = (url: string): string => {
    //     const validExtensions = [".jpg", ".jpeg", ".png"];
    //     const extension = url?.split(".").pop()?.toLowerCase();
    //     if (extension && validExtensions.includes(`.${extension}`)) {
    //         return url;
    //     }
    //     return "https://team1consulting.com/weconnect/uploads/assets/231018-230311-team1-consultancy1.png";
    // };

    const getImageSrc = (asset: Asset): string => {
        const url = asset.asset_attachement;
        const validExtensions = [".jpg", ".jpeg", ".png"];
        const extension = url?.split(".").pop()?.toLowerCase();
        if (extension && validExtensions.includes(`.${extension}`)) {
            return url; // real image file
        }

        // Map asset_name to static image
        const name = asset.asset_name.toLowerCase().replace(/\s+/g, "_");
        const staticImagesMap: Record<string, string> = {
            "employee_handbook": "/assets/digital/Employee_Handbook.png",
            "extension_list": "/assets/digital/extension_list.png",
            "human_resources_brochure": "/assets/digital/human_resources_brochure.png",
            "presentation_template": "/assets/digital/presentation_template.png",
            "service_catalogue": "/assets/digital/service-catalogue.png",
        };

        return staticImagesMap[name] || "https://team1consulting.com/weconnect/uploads/assets/231018-230311-team1-consultancy1.png";
    };

    return (
        <div className="card mb-3">
            {/* <div className="card-header">
                <h5 className="card-title mb-0">{title}</h5>
            </div> */}
            <div className="card-body">
                <div className="row">
                    {assets.length === 0 && (
                        <div className="col-12 text-muted">No assets found.</div>
                    )}
                    {assets.map((asset, index) => (
                        <div className="col-xl-4 col-sm-6 col-12 mb-4" key={index}>
                            <div className="card h-100">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h6 className="card-title mb-0">{asset.asset_name}</h6>
                                    <div className="d-flex gap-1">
                                        <a
                                            href={asset.asset_attachement}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-outline-secondary btn-sm"
                                        >
                                            View
                                        </a>
                                        <a
                                            href={asset.asset_attachement}
                                            target="_blank"
                                            rel="noreferrer"
                                            download={asset.asset_name}
                                            className="btn btn-primary custom_button btn-sm"
                                        >
                                            Download
                                        </a>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-center">
                                    <ImageWithBasePath
                                        className="rounded object-fit-contain"
                                        src={getImageSrc(asset)}
                                        alt={asset.asset_name}
                                        width={250}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AssetSection;
